import {complement, isNil} from 'ramda'

import {makeGetSearchParameter} from './generic'

import type {BoundingBox} from '@findhotel/sapi'

const hasValue = complement(isNil)

const getIsValidBoundingBox = (
  maybe: BoundingBox | Array<number> | undefined
): maybe is BoundingBox =>
  maybe && maybe.length && maybe.filter(hasValue).length === 4

export const getBoundingBox = (
  searchParameters: URLSearchParams
): BoundingBox | undefined => {
  const getParameter = makeGetSearchParameter(searchParameters)
  const boundingBox = getParameter('boundingBox', 'number', true)
  return getIsValidBoundingBox(boundingBox) ? boundingBox : undefined
}
